export const GALLERY = [
  { src: "/img/contact-banner.jpg", alt: "A healthy smile begins with a professional cleaning – Dra. Cora", wide: true },
  { src: "/img/managua-banner.jpg", alt: "Nuestra nueva sucursal en Managua – SunCare Dental team", wide: true },
  { src: "/img/sjds-promo.jpg", alt: "Dra. Cora Baltodano, dentist in San Juan del Sur" },
  { src: "/img/cora-team.jpg", alt: "SunCare Dental team" },
  { src: "/img/holiday-smile.jpg", alt: "Dra. Cora treating a patient – your holiday smile starts now" },
  { src: "/img/exceptional-care.jpg", alt: "Exceptional care. Beautiful smiles.", wide: true },
  { src: "/img/hero-photo.jpg", alt: "Dra. Cora Baltodano at her clinic" },
  { src: "/img/fb-cover.jpg", alt: "SunCare Dental", wide: true },
  { src: "/img/managua-entrance.jpg", alt: "SunCare Dental Managua entrance" },
  { src: "/img/cora1.jpg", alt: "Dra. Cora Baltodano" },
  { src: "/img/cora3.jpg", alt: "Dra. Cora Baltodano" },
];
